import React, {useState} from "react";
import BaseTimeline from "../../components/Base/BaseTimeline";
import KYC from "../../components/settings/KYC";
import Navbar from "../../components/Navbar";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {logoutUser} from "../../redux/auth/authSlice";
import {useNavigate} from "react-router-dom";
import {RouteNames} from "../../constants";

const Onboarding = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { user }  = useAppSelector(state=>state.auth);
    const [formStep, setFormStep] = useState(0);

    const logout = ()=>{
        dispatch(logoutUser());
    }


    return (
        <div className="onboarding-page">
            <Navbar isOnboarding toggleShowSidebar={()=>{}} user={user} logout={logout} />
            <div className="section-card">
                <div className="step">
                    <div className="step-main">
                        <div className="step-number">0{formStep+1}</div>
                        <BaseTimeline timelineStep={0}>
                            <div>Personal Data</div>
                            <div></div>
                        </BaseTimeline>
                    </div>
                </div>
                <div className="ob w-full">
                    <div className="ob__head">
                        Tell us a bit more about yourself
                    </div>
                    <div className="form">
                        <div className="form__head">
                            Personal Information
                        </div>
                        <KYC
                            isOnboarding={true}
                            onSuccess={()=>{
                                navigate(RouteNames.DASHBOARD)
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Onboarding;